import { resolveTagConfig } from './templateTags/engine';
import customerOrderTags from './templateTags/customerOrder';
import customerOfferTags from './templateTags/customerOffer';
import customerDdtTags from './templateTags/customerDdt';
import customerInvoiceTags from './templateTags/customerInvoice';
import customerInvoiceAccTags from './templateTags/customerInvoiceAcc';
import supplierOrderTags from './templateTags/supplierOrder';
import supplierDdtTags from './templateTags/supplierDdt';


export function prepareCustomerOrderTemplateData(order) {
    return resolveTagConfig(customerOrderTags, order);
}

export function prepareCustomerOfferTemplateData(offer) {
    return resolveTagConfig(customerOfferTags, offer);
}

export function prepareCustomerDdtTemplateData(data, dataOrder) {
    return resolveTagConfig(customerDdtTags, data, dataOrder);
}

export function prepareInvoiceTemplateData(invoice, order, rows, paymentConditionName) {
    return resolveTagConfig(customerInvoiceTags, invoice, order, rows, paymentConditionName);
}

export function prepareInvoiceAccTemplateData(invoice, order, rows, paymentConditionName) {
    return resolveTagConfig(customerInvoiceAccTags, invoice, order, rows, paymentConditionName);
}

export function prepareSupplierOrderTemplateData(order) {
    return resolveTagConfig(supplierOrderTags, order);
}

export function prepareSupplierDdtTemplateData(data, rifOrder, address) {
    return resolveTagConfig(supplierDdtTags, data, rifOrder, address);
}
